import { Link } from 'react-router-dom'
export default function SimpleDisclosure() {
  return (
    <div className="legal-page fade-in">
      <div className="container">
        <div className="legal-card neon-border">
          <div className="header">
            <Link to="/"> <img src="public/clabs_logo.png" alt="CLabs Logo" className="logo" /> </Link>
            <h1>Simple Disclosure</h1>
            <span className="date">Last updated January 8th 2026</span>
          </div>

          <div className="content">
            <p>Like many other companies, Consilient Labs, Inc (CLabs) subscribes to the concept of:</p>
            
            <blockquote>
                <strong>Privacy is a fundamental human right.</strong>
                <p>It's also one of our core values.</p>
                <p>Which is why we design our products and services to protect it.</p>
            </blockquote>

            <h3>In a nutshell:</h3>
            <ul>
              <li>CLabs only links your personal identifiable information to the queries you post to the system
                <ul>
                  <li>And you can delete this at ANY POINT IN TIME</li>
                  <li>You can also delete your account at ANY POINT IN TIME</li>
                </ul>
              </li>
              <li>Sorry, no restore, as we actually delete your data</li>
            </ul>

            <ul>
              <li>As operational necessity, CLabs gathers telemetry, logs, et. al none of which is linked to your identity</li>
            </ul>

            <ul>
              <li>CLabs uses several 3rd party cloud services, including but not limited to:
                <ul>
                  <li>AWS</li>
                  <li>Google</li>
                </ul>
              </li>
            </ul>

            <p>CLabs makes no warranties or representations about their respective privacy policies.</p>

            <ul>
              <li>At the time of writing the CLabs infrastructure is hosted in The United States of America</li>
              <li>CLabs may offer links to 3rd party sources by clicking any such link the terms and conditions and data privacy do take precedence.</li>
              <li>CLabs will not share and/or sell any Personal Identifiable Information with any 3rd party without your prior written consent.</li>
            </ul>

            <div className="alert warning">
              Should you be concerned about any of the above you are strongly encouraged to <strong>DO NOT USE CLabs</strong>.
            </div>

            <p style={{ textAlign: "center" }}>For questions and comments, please reach out to <a href="mailto:contact@consilientlabs.com">contact@consilientlabs.com</a></p>

            <div className="legal-navigation">
              <h3>You can find the full legalities, here:</h3>
              <div className="nav-links">
                    <p><Link to="/policy">Privacy Policy</Link></p>
                    <p><Link to="/legalTerms">Terms of Service</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <style>{`
        .legal-page { 
          padding: 4rem 0; 
          min-height: 80vh; 
        }
        .legal-card { 
          background: var(--card-bg); 
          backdrop-filter: var(--glass-blur);
          border: 1px solid var(--glass-border);
          border-radius: 1.5rem;
          padding: 3rem;
          max-width: 900px;
          margin: 0 auto;
        }
        .header { 
          text-align: center; 
          margin-bottom: 3rem; 
          border-bottom: 1px solid var(--glass-border); 
          padding-bottom: 2rem; 
        }
        .logo { 
          height: 60px; 
          margin-bottom: 1rem; 
        }
        h1 { 
          font-size: 2.5rem; 
          margin-bottom: 0.5rem; 
          background: var(--text-gradient); 
          -webkit-background-clip: text; 
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: var(--primary-color); 
        }
        .date { 
          color: var(--text-muted); 
          font-size: 0.9rem; 
          text-transform: uppercase; 
          letter-spacing: 1px; 
        }
        .content { 
          font-size: 1.1rem; 
          line-height: 1.8; 
          color: var(--text-main); 
        }
        blockquote { 
          border-left: 4px solid var(--primary-color);
          padding-left: 1.5rem; margin: 2rem 0;
          font-style: italic;
          background: var(--input-bg);
          padding: 1.5rem; 
          border-radius: 0 1rem 1rem 0;
        }
        p { 
          margin-bottom: 1rem; 
        }
        .subsection-title {
          font-weight: 600;
        }
        ul { 
          margin: 1rem 0; 
          padding-left: 1.5rem; 
        }
        li { 
          margin-bottom: 0.5rem; 
        }
        .alert { 
          padding: 1.5rem;
          border-radius: 1rem;
          margin: 2rem 0;
          text-align: center;
        }
        .alert.warning {
          background: rgba(248, 113, 113, 0.1);
          border: 1px solid rgba(248, 113, 113, 0.3);
          color: var(--error);
        }
        .legal-navigation {
          margin-top: 4rem;
          padding-top: 2rem;
          border-top: 1px solid var(--glass-border);
          text-align: center;
        }
        .nav-links {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 1.5rem; }

      `}</style>
    </div>
  );
}

